import * as yup from "yup";

export const LocationsSetupValidationSchema = yup.object().shape({
  locationName: yup
  .string()
  .required("Location Name is required")
  .min(1, "Minimum length 1 characters")
  .max(50, "Maximum length 50 characters"),
	notes: yup
    .string()
    .max(100, "Maximum length 100 characters"),
});
